import { render, staticRenderFns } from "./veBarR.vue?vue&type=template&id=5c7e4e56&"
import script from "./veBarR.vue?vue&type=script&lang=js&"
export * from "./veBarR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports